module.exports = __webpack_public_path__ + "assets/tree.916b7905.svg";